export default {
    general: {
        add:     'Dodaj',
        edit:    'Uredi',
        delete:  'Izbriši',
        cancel:  'Prekliči',
        save:    'Shrani',
        close:   'Zapri',
        confirm: 'Potrdi',
        yes:     'Da',
        no:      'Ne',
        back:    'Nazaj',
        show_password: 'Pokaži geslo',
        hide_password: 'Skrij geslo',
        no_data: 'Ni podatkov',
        loading: 'Nalaganje …',
        today:   'Danes',
        status:  'Status',
        refresh: 'Osveži',
        search:  'Iskanje',
    },
    // Trajanje se pove tako, kot ga pove hotel: „18 min“ pod uro, „1 h 05“ nad njo.
    // Minute so dvomestne, ker „1 h 5“ bere kot ura in pet ur.
    duration: {
        minutes: '{minutes} min',
        hours:   '{hours} h {minutes}',
    },
    // Vzdrževanje: kaj je pokvarjeno in kdo to popravlja.
    maintenance: {
        title:              'Vzdrževanje',
        description:        'Kaj je pokvarjeno in kdo to popravlja.',
        report:             'Prijavi okvaro',
        reported:           'Okvara je prijavljena.',
        fault:              'Okvara',
        area:               'Del objekta',
        area_hint:          'Če ne gre za sobo — dvigalo, kuhinja, parkirišče …',
        room_hint:          'Pusti prazno, če okvara ni v sobi.',
        no_room:            'Brez sobe',
        description_label:  'Opis',
        severity:           'Resnost',
        severity_blocking:  'Blokira sobo',
        severity_normal:    'Navadna',
        severity_cosmetic:  'Kozmetična',
        status_open:        'Prijavljena',
        status_assigned:    'Dodeljena',
        status_in_progress: 'V delu',
        status_resolved:    'Popravljena',
        status_closed:      'Zaključena',
        status_cancelled:   'Preklicana',
        status_duplicate:   'Podvojena',
        start:              'Prevzemi',
        started:            'Okvara je prevzeta.',
        resolve:            'Popravljeno',
        resolved:           'Okvara je označena kot popravljena.',
        resolution:         'Kaj je bilo narejeno',
        resolution_hint:    'Kratek zapis za tistega, ki bo isto okvaro videl čez pol leta.',
        nobody:             'Nihče',
        empty:              'Ni odprtih okvar.',
        filter_mine:        'Moje',
        filter_unassigned:  'Nedodeljene',
        filter_open:        'Vse odprte',
        load_failed:        'Okvar ni bilo mogoče naložiti.',
        action_failed:      'Dejanja ni bilo mogoče izvesti.',
    },
    room: {
        room: 'Soba',
    },
    nav: {
        calendar:   'Koledar',
        services:    'Storitve',
        maintenance: 'Vzdrževanje',
        logout:       'Odjava',
        theme:        'Videz',
        theme_light:  'Svetlo',
        theme_dark:   'Temno',
        theme_system: 'Sistemsko',
        language:     'Jezik',
        language_sl:  'Slovenščina',
        language_en:  'Angleščina',
        today:        'Danes',
        sheet:        'Razpored',
        statistics:   'Statistika',
        timeline:   'Pregled',
    },
    login: {
        title:    'Prijava',
        subtitle: 'Portal za izvajalce storitev — velnes, izposoja, dvorane',
        username: 'Uporabniško ime',
        password: 'Geslo',
        submit:   'Prijava',
        failed:   'Napačno uporabniško ime ali geslo',
    },
    property: {
        property:   'Objekt',
        properties: 'Objekti',

        unavailable_title:       'Objekt ni znan',
        unavailable_description: 'Ta račun ne more prebrati seznama objektov (manjka pravica property:read), zato portal ne ve, za katero hišo gre. Obrni se na administratorja.',

        rooms_restricted_title:       'Številke sob niso na voljo',
        rooms_restricted_description: 'Nekatere naloge nimajo številke sobe. Delo je prikazano, sobo pa je treba poiskati po seznamu.',
    },
    today: {
        title:    'Danes',
        subtitle: 'Sobe za današnji poslovni dan',

        progress: 'Opravljeno',

        my_rooms:               'Moje sobe',
        unassigned_rooms:       'Nedodeljene sobe',
        unassigned_description: 'Te sobe še niso dodeljene nikomur. Če katero prevzameš, pritisni Začni.',

        floor:         'Nadstropje {floor}',
        floor_unknown: 'Neznano nadstropje',

        empty: 'Za danes zate ni nobene sobe.',
    },
    sheet: {
        title:    'Razpored',
        subtitle: 'Vse sobe današnjega poslovnega dne',

        generate:         'Ustvari razpored',
        generate_confirm: 'Ustvari naloge za današnji poslovni dan. Naloge, ki že obstajajo, ostanejo nedotaknjene.',
        generate_failed:  'Razporeda ni bilo mogoče ustvariti.',
        generated_message: 'Ustvarjenih nalog: {count}',

        filter_status: 'Status',
        filter_kind:   'Vrsta dela',
        all_statuses:  'Vsi statusi',
        all_kinds:     'Vse vrste dela',
        floor_summary:  '{rooms} sob · {open} za delo',
        person_summary: 'še za delo: {open} od {total}',
        group_by_floor:  'Po nadstropjih',
        group_by_person: 'Po osebah',

        empty: 'Za ta dan ni nalog. Če nočni zaključek še ni tekel, pritisni Ustvari razpored.',

        assign_restricted_title:       'Dodeljevanje ni na voljo',
        assign_restricted_description: 'Ta račun ne more prebrati seznama osebja gospodinjstva tega objekta (manjka pravica housekeeping:inspect), zato sob ni mogoče dodeliti.',
    },
    timeline: {
        search: 'Soba ali oseba',
        no_match: 'Za to iskanje ni zapisov.',
        title:       'Pregled dneva',
        description: 'Kdaj je soba prišla v delo, kdo jo je prevzel in uredil, kdo pregledal.',
        empty:       'Danes se še ni nič zgodilo.',
        started:     'prevzeta v čiščenje',
        finished:    'počiščena',
        skipped:     'preskočena',
        inspected:   'sprejeta',
        days_today: 'Danes',
        days_3: 'Zadnji 3 dnevi',
        days_7: 'Zadnjih 7 dni',
        days_14: 'Zadnjih 14 dni',
    },
    task: {
        status_pending:     'Čaka',
        status_in_progress: 'V delu',
        status_done:        'Opravljeno',
        status_inspected:   'Pregledano',
        status_skipped:     'Preskočeno',

        kind_departure: 'Odhod',
        kind_stayover:  'Ostaja',
        kind_arrival:   'Prihod',
        kind_dirty:             'Za urediti',
        kind_dirty_done:        'Urejeno',

        kind_departure_description: 'Gost je odšel. Sobo v celoti pripravi: preobleci posteljo, počisti kopalnico in dopolni potrošni material.',
        kind_stayover_description:  'Gost ostaja v sobi. Dnevno čiščenje okrog njegovih stvari — postelja, kopalnica, koši, brisače.',
        kind_arrival_description:   'Soba je prazna in danes pride gost. Pripravi jo in preglej, preden vstopi.',
        kind_dirty_description: 'Soba čaka na ureditev, čeprav ta dan nihče ne prihaja in nihče ni prespal. Pripravi jo do konca.',

        consequence_done:           'Soba je počiščena. Ko je sprejeta, je pripravljena za naslednjega gosta.',
        consequence_inspected:      'Soba je sprejeta in pripravljena za naslednjega gosta.',
        consequence_stayover_done:  'Dnevno čiščenje je opravljeno, soba pa ostane zasedena — ni pripravljena za novega gosta.',
        guest_still_in_room:        'Gost je še v sobi',

        room_unknown: 'Neznana soba',
        floor:         'Nadstropje',
        business_date: 'Poslovni dan',
        started_at:    'Začeto',
        finished_at:   'Končano',
        inspected_at:  'Pregledano',
        notes:         'Opomba',

        // Norma je pripomoček za načrtovanje, ne ocena dela. Nikjer ni napisana kot
        // graja: soba čez normo je soba, ki je norma ni opisala.
        norm:       'Norma',
        norm_short: 'norma {value}',
        remaining:              'še {value}',
        over_by:                'čez {value}',
        over_norm:  'Čez normo za {value}',
        elapsed:    'Traja',
        duration:   'Trajanje',

        unassigned:        'Nedodeljeno',
        worked_by:              'Opravljeno: {name}',
        awaiting_inspection:    'Čaka pregled',

        due_by:                 'do {time}',

        priority:               'Prednost',
        assigned_to:       'Dodeljeno',
        assigned_to_you:   'Tebi',
        assigned_to_other: 'Drugi osebi',

        assign:           'Dodeli',
        assign_to:        'Dodeli osebi',
        assigned_message: 'Soba je dodeljena',

        actions: 'Dejanja',

        start:            'Začni',
        started_message:  'Soba je začeta',

        finish:           'Končaj',
        finished_message: 'Soba je končana',

        finish_without_start:         'Delo je že opravljeno',
        finish_without_start_confirm: 'Ta soba še ni bila začeta. Zabeležili jo bomo kot začeto zdaj in takoj zaključeno, zato čas čiščenja ne bo pravilen. Če delo šele začenjaš, uporabi Začni.',

        skip:            'Preskoči',
        skip_confirm:    'Soba ne bo počiščena. Zapiši razlog, da nadzor ve, zakaj.',
        skipped_message: 'Soba je preskočena',

        inspect:           'Potrdi sobo',
        inspect_confirm:   'S tem potrdiš, da je soba pregledana in pripravljena za gosta. Tega ni mogoče preklicati.',
        inspected_message: 'Soba je potrjena',

        note_title: 'Opomba',
        note_hint:  'Kar zapišeš, gre skupaj s Končaj ali Preskoči in to prebere nadzor.',

        reason_do_not_disturb: 'Ne moti',
        reason_guest_declined: 'Gost je odklonil čiščenje',
        reason_no_access:      'Do sobe ni bilo dostopa',

        not_found:  'Naloge ni mogoče najti.',
        no_actions: 'Za to sobo nimaš razpoložljivih dejanj.',

        closed_done:      'Soba je počiščena in čaka na pregled.',
        closed_inspected: 'Soba je sprejeta in pripravljena. Delo za danes je zaključeno.',
        closed_skipped:   'Soba je bila preskočena. Za danes tu ni več dela.',

        load_failed:   'Nalog ni bilo mogoče naložiti.',
        action_failed: 'Dejanja ni bilo mogoče izvesti.',
    },
    statistics: {
        title:    'Statistika',
        subtitle: 'Opravljeno delo po osebah, vrstah dela in dnevih',

        period_today: 'Danes',
        period_week:  '7 dni',
        period_month: 'Ta mesec',

        range: 'od {from} do {to}',

        tasks:     'Sob',
        done:      'Počiščeno',
        inspected: 'Pregledano',
        skipped:   'Preskočeno',

        average:    'Povprečje na sobo',
        norm:       'Norma na sobo',
        norm_short: 'norma {value}',
        per_room:   'na sobo',
        worked:     'Skupaj dela',
        // Imenovalec povprečja se pove naglas: povprečje štirih sob in povprečje
        // štiridesetih nista isto dejstvo in ne smeta biti videti enako.
        timed:      'Merjenih sob',

        by_person:      'Po osebah',
        by_person_hint: 'Delo se šteje tistemu, ki ga je opravil — kdor je pritisnil Začni. Sobe, ki jih ni začel nihče, so v vrstici Nedodeljeno.',
        by_kind:        'Po vrsti dela',
        by_day:         'Po dnevih',

        unassigned:     'Nedodeljeno',
        person_unknown: 'Neznana oseba',

        empty:       'V tem obdobju ni zabeleženega dela.',
        load_failed: 'Statistike ni bilo mogoče naložiti.',
    },
    calendar: {
        title: 'Koledar terminov',
        description: 'Kaj je prosto in kaj zasedeno v zmogljivosti.',
        no_centres: 'Ta račun ni vezan na nobeno zmogljivost.',
        empty: 'Za ta dan ni odprtih terminov.',
        time: 'Ura',
        resource: 'Sredstvo',
        free: 'prosto',
        legend_booked: 'naročeno',
        legend_out: 'izdano / v teku',
        legend_done: 'vrnjeno / končano',
        taken: 'zasedeno',
    },
    service: {
        title: 'Moje storitve',
        description: 'Termini, ki jih izvajaš danes. Zaporedje je po uri.',
        empty: 'Za ta dan ni terminov.',
        today: 'Danes',
        tomorrow: 'Jutri',
        view_day: 'Dan',
        view_week: 'Teden',
        view_month: 'Mesec',
        includes_today: 'Vključuje danes',
        period_count: 'Terminov: {count}',
        period_hours: 'Skupaj {hours} h',
        previous_day: 'Prejšnji dan',
        next_day: 'Naslednji dan',
        all_day: 'Ves dan',
        days_count: '{count} dni',
        hand_over: 'Izdaj',
        handed_over: 'Izdano',
        handed_over_done: 'Izdano gostu.',
        take_back: 'Vrnjeno',
        returned: 'Vrnjeno',
        returned_done: 'Zabeleženo kot vrnjeno.',
        to_hand_over: 'Za izdajo',
        hire_hours: 'Izdaja {pickup} · vračilo {back}',
        walk_in: 'Brez gosta',
        status_booked: 'Naročeno',
        status_in_progress: 'V teku',
        status_completed: 'Končano',
        start: 'Začni',
        book: 'Rezerviraj',
        booked: 'Termin je rezerviran',
        book_title: 'Nov termin',
        book_service: 'Storitev',
        book_guest: 'Gost',
        book_guest_hint: 'Ime, kot ga pove gost. Lahko pustiš prazno.',
        book_time: 'Prosti termini',
        book_source: 'Kdo je naročil',
        source_walk_in: 'Gost pri meni',
        source_phone: 'Po telefonu',
        book_no_slots: 'Za ta dan ni prostih terminov.',
        book_failed: 'Termina ni bilo mogoče rezervirati.',
        book_no_second: 'Za to uro ni proste druge terapevtke/terapevta. Izberi drugo uro.',
        started: 'Storitev je v teku',
        finish: 'Zaključi',
        finished: 'Storitev je zaključena',
        finish_title: 'Zaključi storitev',
        finish_question: 'Kako je gost plačal?',
        finish_free_hint: 'Ta storitev nima cene — zaključi se brez obračuna.',
        settle_folio: 'Na sobo',
        settle_folio_hint: 'Gre na kartico gosta, plača ob odjavi.',
        settle_folio_no_stay: 'Ni mogoče — termin ni vezan na bivanje.',
        settle_paid: 'Takojšnje plačilo',
        settle_paid_hint: 'Na kartico ne gre nič.',
    },
    license: {
        title:   'Ta storitev ni vključena',
        lead:    'Skupine in dogodki niso del naročnine te hiše, zato ta portal ne more prikazati ničesar.',
        switch_account: 'Prijavi se z drugim računom',
        contact: 'Za vklop se obrni na sistemskega skrbnika. Podatki hiše ostanejo nedotaknjeni.',
    },
    errors: {
        generic_error: 'Prišlo je do napake',
        invalid_data:  'Neveljavni podatki',
        not_found:     'Ni najdeno',
        unauthorized:  'Za to dejanje nimaš pravice',
        session_expired: 'Seja je potekla. Prijavi se znova — narejeno ni bilo nič.',
        conflict:      'Zapis že obstaja',
        on_add:        'Napaka pri dodajanju',
        on_load:       'Napaka pri branju',
        on_edit:       'Napaka pri shranjevanju',
    },
    success: {
        add:  'Uspešno dodano',
        edit: 'Uspešno shranjeno',
    },
    validation: {
        required: 'To polje je obvezno',
        email:    'Neveljaven e-naslov',
    },
}
